import React from 'react';
import '../pages/TsKayitPublicPage.css';

export function TsKayitHeader({
  title = 'Teknik Servis Kayıt Formu',
  showYeniKayit = false,
  onYeniKayit,
}) {
  return (
    <header className="ts-kayit-header">
      <div className="ts-kayit-header-bg" aria-hidden="true" />
      <div className="ts-kayit-header-inner">
        {showYeniKayit && (
          <button type="button" className="ts-kayit-yeni-kayit" onClick={onYeniKayit}>
            Yeni kayıt
          </button>
        )}
        <div className="ts-kayit-logo-wrap">
          <img src="/assets/img/logo.png" alt="Ünmak" className="ts-kayit-logo" />
        </div>
        <h1>{title}</h1>
      </div>
    </header>
  );
}

export default function TsKayitShell({
  children,
  title,
  showYeniKayit = false,
  onYeniKayit,
}) {
  return (
    <div className="ts-kayit-page">
      <div className="ts-kayit-card">
        <TsKayitHeader
          title={title}
          showYeniKayit={showYeniKayit}
          onYeniKayit={onYeniKayit}
        />
        <div className="ts-kayit-body">{children}</div>
      </div>
    </div>
  );
}
